import { FC } from 'react';
import { Box, Avatar, Chip, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { MessageType } from '../../../../type/dto/RequestResponseDTO';
import { getFormattedDate } from '../../../../shared/util/dateHelper';

interface MessageHeaderProps {
    userName: string;
    userRole: string;
    messageType: MessageType;
    createdAt: string;
}

const getMessageTypeColor = (type: MessageType) => {
    switch (type) {
        case MessageType.TEXT:
            return 'default';
        case MessageType.IMAGE:
            return 'info';
        case MessageType.OFFER:
            return 'success';
        case MessageType.SYSTEM:
            return 'warning';
        default:
            return 'default';
    }
};

export const MessageHeader: FC<MessageHeaderProps> = ({
    userName,
    userRole,
    messageType,
    createdAt
}) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5 }}>
            <Avatar
                sx={{
                    width: 36,
                    height: 36,
                    bgcolor: userRole === 'Client' ? 'primary.main' : 'secondary.main',
                }}
            >
                <PersonIcon fontSize="small" />
            </Avatar>
            <Box sx={{ flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        {userName}
                    </Typography>
                    <Chip
                        label={userRole}
                        size="small"
                        color={userRole === 'Client' ? 'primary' : 'secondary'}
                        sx={{ height: 20 }}
                    />
                    <Chip
                        label={messageType}
                        size="small"
                        color={getMessageTypeColor(messageType)}
                        variant="outlined"
                        sx={{ height: 20 }}
                    />
                </Box>
                <Typography variant="caption" color="text.secondary">
                    {getFormattedDate(createdAt)}
                </Typography>
            </Box>
        </Box>
    );
};

